import React from 'react';
import { Alert, Button } from 'antd';
import { useDraftLocalStorage } from '../../lib';
import {
  shutdownEmitter,
  shutdownEvtNames,
} from '../../../../../shared/constants';
import { initDraftData, insertDraftDataKeys } from './constants';
import { reduceCb, useIsValuesFetching } from './utils';
import styles from './DraftInfoWithActions.module.scss';

const { setDraftSelectValueBuilder, setDraftCityValue } = shutdownEvtNames;

const DraftInfoWithActions = ({ form }) => {
  const [draft, setDraft] = useDraftLocalStorage();

  const isFetching = useIsValuesFetching();

  const insertDraft = () => {
    const data = Object.entries(draft).reduce(reduceCb, initDraftData);
    form.setFieldsValue(data[insertDraftDataKeys.restValues]);

    Object.entries(data[insertDraftDataKeys.selectValues]).forEach(
      ([key, value]) =>
        shutdownEmitter.emit(setDraftSelectValueBuilder(key), value)
    );

    shutdownEmitter.emit(
      setDraftCityValue,
      data[insertDraftDataKeys.cityDependentValues]
    );
  };

  const deleteDraft = () => setDraft(null);

  const insertAndDeleteDraft = () => {
    insertDraft();
    deleteDraft();
  };

  return draft ? (
    <Alert
      className={styles.root}
      message="У вас есть сохраненный черновик"
      description={
        <div className={styles.actions}>
          <div className={styles.col}>
            <Button
              onClick={deleteDraft}
              type="danger"
            >
              Удалить
            </Button>
            <Button
              onClick={insertAndDeleteDraft}
              disabled={isFetching}
            >
              Вставить и удалить
            </Button>
          </div>

          <Button
            onClick={insertDraft}
            type="primary"
            disabled={isFetching}
          >
            Вставить
          </Button>
        </div>
      }
    />
  ) : null;
};

export default DraftInfoWithActions;
